import React from 'react';

import { styled, StyleSheet } from '@rexlabs/styling';
import { FormRenderer as RexlabsFormRenderer } from '@rexlabs/form-renderer';
import Box from '@rexlabs/box';
import { Form as RexlabsForm } from '@rexlabs/form';
import { ButtonGroup, PrimaryButton, SecondaryButton } from '@rexlabs/button';
import SlideoutContainer from '../slide-out/slideout-container';
import TextInput from '../inputs/text-input/text-input';

const defaultStyles = StyleSheet({
  formTitle: {
    padding: '0 32px 24px 32px',
    background: '#f2f2f2',
    overflow: 'auto'
  },
  content: {
    background: 'white'
  },
  staticBtnGroup: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    margin: '0 !important',
    width: '100%',
    '> button': {
      flexGrow: 1,
      margin: 0,
      boxShadow: 'none'
    }
  },
  brand: {
    background: 'var(--brand_primary_color)',
    borderColor: 'var(--brand_primary_color)',
    color: 'var(--brand_contrast_color)',
    textDecoration: 'none',
    borderRadius: '0',
    height: 50,
    ':hover': {
      background: 'var(--brand_primary_color)',
      borderColor: 'var(--brand_primary_color)',
      color: 'var(--brand_contrast_color)',
      opacity: 0.85
    },
    ':active': {
      background: 'var(--brand_primary_color)',
      borderColor: 'var(--brand_primary_color)',
      color: 'var(--brand_contrast_color)',
      opacity: 0.75
    }
  },
  dark: {
    background: '#333',
    borderColor: '#333',
    textDecoration: 'none',
    borderRadius: '0',
    height: 50,
    ':hover': {
      background: '#333',
      borderColor: '#333',
      opacity: 0.85
    },
    ':active': {
      background: '#333',
      borderColor: '#333',
      opacity: 0.75
    }
  }
});

function SlideoutFormRenderer({
  styles: s,
  onClose,
  submitting,
  ...formProps
}) {
  return (
    <RexlabsFormRenderer {...formProps} TextInput={TextInput}>
      {({ normalizedFields, form, schema }) => {
        return (
          <RexlabsForm>
            <Box {...s('formTitle')}>
              <h3
                className={'h3'}
                style={{ fontSize: '2rem', lineHeight: '2.4rem' }}
              >
                {schema?.definition?.label}
              </h3>
              {schema?.definition?.description && (
                <span>{schema?.definition?.description}</span>
              )}
            </Box>

            <SlideoutContainer
              style={{ background: 'white', paddingBottom: 40 }}
            >
              {normalizedFields.default.no_group.map(
                ({ fieldProps, Field }, index) => (
                  <Field key={index} {...fieldProps} />
                )
              )}
            </SlideoutContainer>

            <ButtonGroup {...s('staticBtnGroup')}>
              <SecondaryButton {...s('dark')} onClick={onClose}>
                Cancel
              </SecondaryButton>
              <PrimaryButton
                {...s('brand')}
                onClick={form.submitForm}
                isLoading={submitting}
              >
                Submit
              </PrimaryButton>
            </ButtonGroup>
          </RexlabsForm>
        );
      }}
    </RexlabsFormRenderer>
  );
}

export default styled(defaultStyles)(SlideoutFormRenderer);
